import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["keyname", "name"];
import { Block } from 'react-login-page';
import { jsx as _jsx } from "react/jsx-runtime";
export var Banner = props => {
  var {
      keyname = 'banner',
      name
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  var key = keyname || name;
  return /*#__PURE__*/_jsx(Block, _extends({}, elmProps, {
    name: key
  }));
};
Banner.displayName = 'Login.Banner';